import { isEmpty } from 'lodash';

import app from '../../scripts/app';
import { getSearchParams } from '../../scripts/utils';
import { trackShowIdentificationScreen } from './select-identification.tracking';
import template from './select-identification.jade';

app.directive('cianAfSelectIdentification', [function() {
    return {
      template,
      scope: {},
      bindToController: {},
      controller: ['$scope', '$timeout', 'userIdentificationService', function($scope, $timeout, userIdentificationService) {
        'ngInject';
        this.taskList = userIdentificationService.getTaskList();

        trackShowIdentificationScreen();

        this.getBackUrl = () => {
          let url = window.location.href;
          let queryParams = getSearchParams();

          const id = userIdentificationService.getDraftId();

          if (id && (!queryParams || !queryParams.id)) {
            url+= (isEmpty(queryParams) ? '?' : '&') + `id=${id}`;
          }

          return url;
        };

        // В FF и Safari нельзя отправить пользователя на ту же страницу, что уже открыта.
        // Поэтому перезагружаем черновик, если открыт именно он.
        this.handleBackUrl = ($event) => {
          let isTheSameUrl = window.location.href === this.getBackUrl();

          if (isTheSameUrl) {
            $event.preventDefault();
            window.location.reload(true);
          }
        };

        this.isLoading = false;

      }],
      controllerAs: 'selectIdentificationCtrl',
    };
  }]);
